import angular from 'angular';

import Document from './document/document.directive';
import DocumentWrap from './document-wrap/document-wrap.directive';
import FileDirective from './file/file.component';
import FileInput from './file-input/file-input.directive';
import StaticUpload from './static-upload/static-upload.component';

const DEPENDENCIES = [
  Document,
  DocumentWrap,
  FileDirective,
  FileInput,
  StaticUpload,
];

export default angular.module('autoboard.fileModule', DEPENDENCIES)
  .name;
